const statesData = [
  {
    state: "Andhra Pradesh",
    iso2: "AP",
    cities: ["Visakhapatnam", "Vijayawada", "Guntur", "Nellore", "Kurnool"],
  },
  {
    state: "Arunachal Pradesh",
    iso2: "AR",
    cities: ["Itanagar", "Tawang", "Ziro", "Pasighat", "Bomdila"],
  },
  {
    state: "Assam",
    iso2: "AS",
    cities: ["Guwahati", "Silchar", "Dibrugarh", "Jorhat", "Tezpur"],
  },
  {
    state: "Bihar",
    iso2: "BR",
    cities: ["Patna", "Gaya", "Bhagalpur", "Muzaffarpur", "Purnia"],
  },
  {
    state: "Chhattisgarh",
    iso2: "CG",
    cities: ["Raipur", "Bhilai", "Bilaspur", "Korba", "Durg"],
  },
  {
    state: "Goa",
    iso2: "GA",
    cities: ["Panaji", "Margao", "Vasco da Gama", "Mapusa", "Ponda"],
  },
  {
    state: "Gujarat",
    iso2: "GJ",
    cities: ["Ahmedabad", "Surat", "Vadodara", "Rajkot", "Bhavnagar"],
  },
  {
    state: "Haryana",
    iso2: "HR",
    cities: ["Chandigarh", "Faridabad", "Gurugram", "Rohtak", "Panipat"],
  },
  {
    state: "Himachal Pradesh",
    iso2: "HP",
    cities: ["Shimla", "Manali", "Dharamshala", "Kullu", "Solan"],
  },
  {
    state: "Jharkhand",
    iso2: "JH",
    cities: ["Ranchi", "Jamshedpur", "Dhanbad", "Bokaro", "Hazaribagh"],
  },
  {
    state: "Karnataka",
    iso2: "KA",
    cities: ["Bengaluru", "Mysuru", "Hubballi", "Mangaluru", "Belagavi"],
  },
  {
    state: "Kerala",
    iso2: "KL",
    cities: ["Thiruvananthapuram", "Kochi", "Kozhikode", "Thrissur", "Kollam"],
  },
  {
    state: "Madhya Pradesh",
    iso2: "MP",
    cities: ["Bhopal", "Indore", "Gwalior", "Jabalpur", "Ujjain"],
  },
  {
    state: "Maharashtra",
    iso2: "MH",
    cities: ["Mumbai", "Pune", "Nagpur", "Nashik", "Aurangabad"],
  },
  {
    state: "Odisha",
    iso2: "OR",
    cities: ["Bhubaneswar", "Cuttack", "Rourkela", "Sambalpur", "Puri"],
  },
  {
    state: "Punjab",
    iso2: "PB",
    cities: ["Chandigarh", "Ludhiana", "Amritsar", "Jalandhar", "Patiala"],
  },
  {
    state: "Rajasthan",
    iso2: "RJ",
    cities: ["Jaipur", "Jodhpur", "Udaipur", "Kota", "Ajmer"],
  },
  {
    state: "Tamil Nadu",
    iso2: "TN",
    cities: ["Chennai", "Coimbatore", "Madurai", "Tiruchirappalli", "Salem"],
  },
  {
    state: "Telangana",
    iso2: "TS",
    cities: ["Hyderabad", "Warangal", "Nizamabad", "Karimnagar", "Khammam"],
  },
  {
    state: "Uttar Pradesh",
    iso2: "UP",
    cities: ["Lucknow", "Kanpur", "Varanasi", "Agra", "Prayagraj"],
  },
  {
    state: "Uttarakhand",
    iso2: "UK",
    cities: ["Dehradun", "Haridwar", "Nainital", "Rishikesh", "Haldwani"],
  },
  {
    state: "West Bengal",
    iso2: "WB",
    cities: ["Kolkata", "Asansol", "Siliguri", "Durgapur", "Howrah"],
  },
];

export default statesData;
